/* import __COLOCATED_TEMPLATE__ from './share-widget.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import canUserManageProject from 'seshy/utils/can-user-manage-project';

export default class PlaylistTeamsShareWidgetComponent extends Component {
  @service store;
  @service currentUser;

  @tracked isConnected = false;

  @tracked errorMessage = null;

  get hasError() {
    return !!this.errorMessage;
  }

  constructor() {
    super(...arguments);
    //console.log('calling TeamPlaylistWidget constructor');
    this.setIsConnected();
  }

  async setIsConnected() {
    var isConnected = false;
    for (let i = 0, len = this.args.teamPlaylists.length; i < len; i++) {
      var teamPlaylist = this.args.teamPlaylists.at(i);
      try {
        var team = await teamPlaylist.team;
        //console.log("this.args.team = ", this.args.team.id);
        //console.log("teamPlaylistTeam = ", team.id);
        if (team.id == this.args.team.id) {
          //console.log('this one is connected');
          isConnected = true;
          this.teamPlaylist = teamPlaylist;
        }
      } catch (err) {
        console.log(
          'caught an error trying to check this teamPlaylist',
          err,
          teamPlaylist,
        );
      }
    }

    this.isConnected = isConnected;
  }

  get isOwned() {
    return this.args.team.id == this.args.playlist.owningTeam.id;
  }

  get canManagePlaylist() {
    return canUserManageProject(this.currentUser, this.args.playlist);
  }

  get notManager() {
    return !this.canManagePlaylist;
  }

  @action
  async connect() {
    this.errorMessage = null;
    //console.log('connect');
    this.teamPlaylist = this.store.createRecord('team-playlist', {
      team: this.args.team,
      playlist: this.args.playlist,
    });
    try {
      await this.teamPlaylist.save();
      this.isConnected = true;
    } catch (error) {
      console.log('caught an error', error);

      let errorCause = error.errors[0];

      if (errorCause.status == '403') {
        this.setForbiddenMessage();
      } else {
        this.setUnknownErrorMessage();
        throw error;
      }
    }
  }

  @action
  async disconnect() {
    this.errorMessage = null;
    //console.log('disconnect');
    this.teamPlaylist.deleteRecord();
    try {
      await this.teamPlaylist.save();
      this.teamPlaylist = null;
      this.isConnected = false;
    } catch (error) {
      console.log('caught an error', error);

      let errorCause = error.errors[0];

      if (errorCause.status == '403') {
        this.setForbiddenMessage();
      } else {
        this.setUnknownErrorMessage();
        throw error;
      }
    }
  }

  setForbiddenMessage() {
    this.errorMessage =
      "You don't seem to be a Team Admin for the team that owns this playlist.";
  }

  setUnknownErrorMessage() {
    this.errorMessage =
      'We ran into an unexpected error while trying update the sharing status. Please try again.';
  }
}
